export default __webpack_public_path__ + "static/media/playIcon.242103ae.svg";